import React from "react";

export const IconTriangleArrow = (props: any) => (
  <svg width="5" height="11" viewBox="0 0 5 11">
    <path d="M0 10.976L5 5.98456L0 0.993164V10.976Z" fill="#888888" />
  </svg>
);
